import { Image, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import React, { useEffect, useState } from "react";
import Svg, { Path } from "react-native-svg";
import { fp, spH, spV, wp } from "utils/normalizeV2";
import { useLocalSearchParams, useRouter } from "expo-router";

import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import { Colors } from "colors";
import ImageView from "../src/image";
import { Images } from "assets";
import ParentScrollView from "components/ParentScrollView";
import VText from "components/VText";
import { trackV2 } from "utils/Segment";
import { useSelector } from "react-redux";

const Profile = () => {
  const userProfile = useSelector((state) => state.ProfileReducer.profileData);
  const router = useRouter(); // Initialize the router
  const local = useLocalSearchParams();
  const localGender = local?.gender || "female";

  useEffect(() => {
    const eventData = {
      user_status: "logged_in",
    };
    trackV2(ANALYTICS_EVENT_NAMES.MY_ACCOUNT_PAGE_VIEWED, eventData);
  }, []);

  const MenuItem = ({ icon, title, route, isSvg = false }) => (
    <TouchableOpacity
      onPress={() => router.push(route)}
      style={styles.menuItem}
    >
      {!isSvg && (
        <Image
          accessibilityLabel={title}
          style={styles.menuItemIcon}
          source={icon}
        />
      )}
      {isSvg && <>{icon()}</>}
      <VText style={styles.menuItemText}>{title}</VText>
      <Image
        accessibilityLabel="Chevron"
        style={styles.chevron}
        source={Images.greyChevron}
      />
    </TouchableOpacity>
  );

  return (
    <ParentScrollView>
      <View style={styles.container}>
        <VText style={styles.header}>My Account</VText>
        <View
          style={{
            width: wp(560),
          }}
        >
          <View style={styles.profileSection}>
            <ImageView
              source={
                userProfile?.profilePicUrl
                  ? userProfile?.profilePicUrl
                  : Images.profile
              }
              resizeMode={ImageView.resizeMode.cover}
              style={{
                width: spH(70),
                height: spH(70),
                borderRadius: spH(35),
              }}
            />
            <View style={styles.userInfo}>
              <VText style={styles.name}>{userProfile?.name}</VText>
              <VText style={styles.gender}>{userProfile?.gender}</VText>
              <VText style={styles.gender}>{userProfile?.emailId}</VText>
            </View>
          </View>
          <View style={styles.menuSection}>
            <MenuItem
              route={`${localGender == 'men' ? '/men' : ''}/editProfile`}
              icon={Images.webmyprofile}
              title="My Profile"
            />
            <MenuItem
              route={`${localGender == 'men' ? '/men' : ''}/my-preferences`}
              icon={() => (
                <View
                  style={{
                    height: wp(20),
                    width: wp(20),
                    marginLeft: -wp(5),
                  }}
                >
                  <Svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <Path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.6667 11.3342C18.6667 12.8075 17.4722 14.0008 16 14.0008C14.5278 14.0008 13.3333 12.8075 13.3333 11.3342C13.3333 9.86085 14.5278 8.66752 16 8.66752C17.4722 8.66752 18.6667 9.86085 18.6667 11.3342ZM14.8889 4.66752L14.8889 7.04751C12.9744 7.54196 11.5556 9.26529 11.5556 11.3342C11.5556 13.4031 12.9744 15.1253 14.8889 15.6209L14.8889 26.8897C14.8889 27.5031 15.3867 28.0009 16 28.0009C16.6144 28.0009 17.1111 27.5031 17.1111 26.8897L17.1111 15.6209C19.0256 15.1264 20.4444 13.4031 20.4444 11.3342C20.4444 9.26529 19.0256 7.54196 17.1111 7.04751L17.1111 4.66752C17.1111 4.05418 16.6144 3.5564 16 3.5564C15.3867 3.5564 14.8889 4.05418 14.8889 4.66752ZM9.77778 21.3342C9.77778 22.8075 8.58334 24.0008 7.11112 24.0008C5.63889 24.0008 4.44558 22.8075 4.44557 21.3342C4.44557 19.8609 5.63889 18.6675 7.11112 18.6675C8.58334 18.6675 9.77778 19.8609 9.77778 21.3342ZM6 4.66752L6 17.0475C4.08556 17.542 2.66667 19.2653 2.66667 21.3342C2.66667 23.4031 4.08556 25.1264 6 25.6209L6 26.8897C6 27.5031 6.49778 28.0009 7.11112 28.0009C7.72556 28.0009 8.22223 27.5031 8.22223 26.8897L8.22223 25.6209C10.1367 25.1264 11.5556 23.4031 11.5556 21.3342C11.5556 19.2653 10.1367 17.542 8.22223 17.0475L8.22223 4.66752C8.22223 4.05418 7.72556 3.5564 7.11111 3.5564C6.49778 3.5564 6 4.05418 6 4.66752ZM27.5556 21.3342C27.5556 22.8075 26.3611 24.0008 24.8889 24.0008C23.4167 24.0008 22.2234 22.8075 22.2234 21.3342C22.2234 19.8609 23.4167 18.6675 24.8889 18.6675C26.3611 18.6675 27.5556 19.8609 27.5556 21.3342ZM23.7778 4.66752L23.7778 17.0475C21.8644 17.542 20.4444 19.2653 20.4444 21.3342C20.4444 23.4031 21.8644 25.1264 23.7778 25.6209L23.7778 26.8897C23.7778 27.5031 24.2744 28.0009 24.8889 28.0009C25.5033 28.0009 26 27.5031 26 26.8897L26 25.6209C27.9144 25.1264 29.3333 23.4031 29.3333 21.3342C29.3333 19.2653 27.9144 17.542 26 17.0475L26 4.66752C26 4.05418 25.5033 3.5564 24.8889 3.5564C24.2744 3.5564 23.7778 4.05418 23.7778 4.66752Z"
                      fill="#212427"
                    />
                  </Svg>
                </View>
              )}
              isSvg={true}
              title="My Preferences"
            />
            <MenuItem
              route={`${localGender == 'men' ? '/men' : ''}/favorites`}
              icon={Images.webfavourite}
              title="Favorites"
            />
            <MenuItem
              route={`${localGender == 'men' ? '/men' : ''}/order-history`}
              icon={Images.webBag}
              title="Order History"
            />
            <MenuItem
              route={`${localGender == 'men' ? '/men' : ''}/manage-saved-cards`}
              icon={Images.webManageCards}
              title="Manage Saved Cards"
            />
            <MenuItem
              route={`${localGender == 'men' ? '/men' : ''}/addresslist?type=profile`}
              icon={Images.webAddresses}
              title="Saved Addresses"
            />
          </View>
        </View>
      </View>
    </ParentScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    padding: 28,
    paddingHorizontal: wp(440),
  },
  header: {
    textAlign: "center",
    fontSize: fp(28),
    fontFamily: "LibreBodoni",
    fontWeight: "350",
  },
  profileSection: {
    flexDirection: "row",
    padding: spV(16),
    gap: 20,
    marginVertical: spV(20),
    paddingTop: 0,
  },
  avatar: {
    width: 80,
    height: 80,
    borderRadius: 40,
    marginRight: 20,
  },
  userInfo: {
    gap: 5,
  },
  name: {
    fontSize: fp(20),
    fontFamily: "JosefinSans",
    fontWeight: "550",
  },
  gender: {
    fontSize: fp(20),
    fontFamily: "JosefinSans",
    color: Colors.black60,
    fontWeight: "350",
  },
  menuSection: {
    paddingRight: spH(20),
    borderRightColor: "#eee",
    marginTop: spV(12),
  },
  menuItem: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: spV(24),
    borderBottomWidth: 1,
    borderBottomColor: "#eee",
    paddingRight: spH(12),
  },
  menuItemText: {
    fontSize: 16,
    marginLeft: 15,
    flex: 1,
  },
  chevron: {
    width: spH(15),
    height: spH(15),
    marginLeft: "auto",
  },
  menuItemIcon: {
    width: spH(21),
    height: spH(21),
  },
});

export default Profile;
